export const isSingleValueObject = (vo) => {
    return vo.voType === "single";
};
export const isMultipleValueObject = (vo) => {
    return vo.voType === "multiple";
};
//# sourceMappingURL=types.js.map